import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upper-part"},[_c('div',{staticClass:"content d-flex"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.logo,"alt":"Ozparts","width":"200px","height":"71px"}})])],1),_c(VSpacer),_c('search-bar'),_c('nav-buttons')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }